import { SALES_ROUTE_PREFIX } from 'components/sales/Routes';

export const isSalesRoute = (): boolean => {
  return window.location.pathname.startsWith(SALES_ROUTE_PREFIX);
};
